module.exports = __webpack_public_path__ + "img/clean.f8ebe9de.png";